// extracted by css-extract-rspack-plugin
export default {"a0":"ViewAllSuggestions-cls1_KjA","a1":"ViewAllSuggestions-cls1_HY5","cls1":"ViewAllSuggestions-cls1_889","cls2":"ViewAllSuggestions-cls2_2ul ViewAllSuggestions-cls1_889"};